import React from 'react'
import * as bs4 from 'reactstrap'
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';
import Navbar from '../../Navbar'
import { ScaleLoader } from 'react-spinners';
import { async } from 'q';
const { proxy } = require('../../../ip_api.config')

class Flim_EditMasterBomLine extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: '',
            previewbom: '',
            isLoading: false,
            arr_item: [],
            arr_check: [],
            arr_show: [],
            arr_save: [],
        }
    }

    componentDidMount() {
        if (localStorage.getItem("ID_User") !== null) {
            this.setState({
                id: this.props.location.state.id_edit
            }, () => {
                this.getOptionBomLine()
            })
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    getOptionBomLine = async () => {
        this.setState({ isLoading: true })
        let option_size = await this.get_option_size()
        let option_type = await this.get_option_type()
        let option_color = await this.get_option_color()
        this.setState({
            option_size: option_size,
            option_color: option_color,
            option_type: option_type,
            isLoading: false,
        }, () => { this.get_masterBomline() })
    }

    get_option_type = async () => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/bom_option_type'
        let arr = []
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify()
        })
            .then(response => response.json())
            .then((responseJson) => {
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        arr.push(
                            <option value={val.name}>{val.name}</option>
                        )
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    get_option_size = async () => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/bom_option_size'
        let arr = []
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify()
        })
            .then(response => response.json())
            .then((responseJson) => {
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        arr.push(
                            <option value={val.name}>{val.name}</option>
                        )
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    get_option_color = async () => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/bom_option_color'
        let arr = []
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify()
        })
            .then(response => response.json())
            .then((responseJson) => {
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        arr.push(
                            <option value={val.name}>{val.name}</option>
                        )
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    get_masterBomline = () => {
        console.log('id', this.state.id)
        this.setState({ isLoading: true })
        let arr = []
        let temp
        let url = proxy.server + '/flim/getMaster_BomLine'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.id
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                // console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    let data = {
                        id: val.id,
                        ibrand1: val.ibrand1,
                        itemG3: val.itemG3,
                        size: val.size,
                        front_back: val.front_back,
                        type: val.type,
                        color: val.color,
                        line_num: val.line_num,
                        new_bom: val.new_bom,
                        qty: val.qty,
                        description: val.description,
                    }

                    arr.push(data)
                })
                temp = this.state.arr_save.concat(arr)
                this.setState({ arr_save: temp, isLoading: false }, () => {
                    console.log("arr_save", this.state.arr_save)
                    //this.preview_masterBomline()
                })
            })
    }

    // preview_masterBomline = () => {
    //     console.log("arr_save", this.state.arr_save)
    //     let arr = []

    //     this.state.arr_save.map(function (val, i) {
    //         arr.push(
    //             <tr>
    //                 <td style={{ fontWeight: 600 }}>{i + 1}</td>
    //                 <td style={{ fontWeight: 600 }}>
    //                     <bs4.Col sm='12' style={{ width: 200 }}>
    //                         <bs4.Input type="text" name="ibrand1" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.ibrand1} />
    //                     </bs4.Col>
    //                 </td>
    //                 <td style={{ fontWeight: 600 }}>
    //                     <bs4.Col sm='12' style={{ width: 200 }}>
    //                         <bs4.Input type="text" name="itemG3" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.itemG3} />
    //                     </bs4.Col>
    //                 </td>
    //                 <td>
    //                     <bs4.Col sm='12' style={{ width: 170 }}>
    //                         <bs4.Input type="select" name="size" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
    //                             <option value={val.size}>{val.size}</option>
    //                             {this.state.option_size}
    //                         </bs4.Input>
    //                     </bs4.Col>
    //                 </td>
    //                 <td>
    //                     <bs4.Col sm='12' style={{ width: 150 }}>
    //                         <bs4.Input type="select" name="front_back" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
    //                             <option value={val.front_back}>{val.front_back}</option>
    //                             <option value="F">F</option>
    //                             <option value="F+B">F+B</option>
    //                         </bs4.Input>
    //                     </bs4.Col>
    //                 </td>
    //                 <td>
    //                     <bs4.Col sm='12' style={{ width: 170 }}>
    //                         <bs4.Input type="select" name="type" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
    //                             <option value={val.type}>{val.type}</option>
    //                             {this.state.option_type}
    //                         </bs4.Input>
    //                     </bs4.Col>
    //                 </td>
    //                 <td>
    //                     <bs4.Col sm='12' style={{ width: 130 }}>
    //                         <bs4.Input type="select" name="color" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
    //                             <option value={val.color}>{val.color}</option>
    //                             {this.state.option_color}
    //                         </bs4.Input>
    //                     </bs4.Col>
    //                 </td>
    //                 <td style={{ fontWeight: 600 }}>{val.line_num}</td>
    //                 <td style={{ fontWeight: 600 }}>
    //                     <bs4.Col sm='12' style={{ width: 200 }}>
    //                         <bs4.Input type="text" name="new_bom" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.new_bom} />
    //                     </bs4.Col>
    //                 </td>
    //                 <td style={{ fontWeight: 600 }}>
    //                     <bs4.Col sm='12' style={{ width: 100 }}>
    //                         <bs4.Input type="text" name="qty" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.qty} />
    //                     </bs4.Col>
    //                 </td>
    //                 <td style={{ fontWeight: 600 }}>
    //                     <bs4.Col sm='12' style={{ width: 200 }}>
    //                         <bs4.Input type="textarea" name="description" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.description} />
    //                     </bs4.Col>
    //                 </td>
    //             </tr>
    //         )
    //     }, this)
    //     this.setState({ previewbom: arr, isLoading: false })
    // }

    handleChangeItem = (index, name, value) => {
        console.log(name, '====', value)
        if (index === 'a') {
            if (name === 'ibrand1') {
                this.state.arr_save.map(function (val, i) {
                    val.ibrand1 = value
                })
            } else if (name === 'itemG3') {
                this.state.arr_save.map(function (val, i) {
                    val.itemG3 = value
                })
            } else if (name === 'size') {
                this.state.arr_save.map(function (val, i) {
                    val.size = value
                })
            } else if (name === 'front_back') {
                this.state.arr_save.map(function (val, i) {
                    val.front_back = value
                })
            } else if (name === 'type') {
                this.state.arr_save.map(function (val, i) {
                    val.type = value
                })
            } else if (name === 'color') {
                this.state.arr_save.map(function (val, i) {
                    val.color = value
                })
            } else if (name === 'new_bom') {
                this.state.arr_save.map(function (val, i) {
                    val.new_bom = value
                })
            } else if (name === 'qty') {
                this.state.arr_save.map(function (val, i) {
                    val.qty = value
                })
            } else if (name === 'description') {
                this.state.arr_save.map(function (val, i) {
                    val.description = value
                })
            }
        } else if (name === 'ibrand1') {
            this.state.arr_save[index].ibrand1 = value
        } else if (name === 'itemG3') {
            this.state.arr_save[index].itemG3 = value
        } else if (name === 'size') {
            this.state.arr_save[index].size = value
        } else if (name === 'front_back') {
            this.state.arr_save[index].front_back = value
        } else if (name === 'type') {
            this.state.arr_save[index].type = value
        } else if (name === 'color') {
            this.state.arr_save[index].color = value
        } else if (name === 'new_bom') {
            this.state.arr_save[index].new_bom = value
        } else if (name === 'qty') {
            this.state.arr_save[index].qty = value
        } else if (name === 'description') {
            this.state.arr_save[index].description = value
        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            console.log('arr_save', this.state.arr_save)
            // this.preview_masterBomline()
        })
    }

    update_masterBomline = () => {
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/flim/update_masterBomline'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    arr: this.state.arr_save
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false })
                        this.props.history.push({
                            pathname: '/Flim/MasterBomLine'
                        })
                    } else {
                        this.setState({ isLoading: false })
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    }
                })
        }
    }

    render() {
        return <div>
            <Navbar nav={'Flim'} menu={'Flim_MasterBomLine'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 20 }}>
                    <bs4.Label style={{ fontSize: 20, fontWeight: 500, marginRight: 20 }} >Edit Master Bomline</bs4.Label>
                    <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.update_masterBomline()}>SAVE</bs4.Button>
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <bs4.Table bordered hover style={{ fontSize: 15 }}>
                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th></th>
                            <th>ibrand1</th>
                            <th>itemG3</th>
                            <th>size</th>
                            <th>front_back</th>
                            <th>type</th>
                            <th>color</th>
                            <th>line_num</th>
                            <th>new_bom</th>
                            <th>qty</th>
                            <th>description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ fontWeight: 600 }}></td>
                            <td style={{ fontWeight: 600 }}>
                                <bs4.Col sm='12' style={{ width: 200 }}>
                                    <bs4.Input type="text" name="ibrand1" onBlur={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td style={{ fontWeight: 600 }}>
                                <bs4.Col sm='12' style={{ width: 200 }}>
                                    <bs4.Input type="text" name="itemG3" onBlur={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 170 }}>
                                    <bs4.Input type="select" name="size" onBlur={(e) => this.handleChangeItem('a', e.target.name, e.target.value)}>
                                        <option value="">-----</option>
                                        {this.state.option_size}
                                    </bs4.Input>
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 150 }}>
                                    <bs4.Input type="select" name="front_back" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)}>
                                        <option value="">-----</option>
                                        <option value="F">F</option>
                                        <option value="F+B">F+B</option>
                                    </bs4.Input>
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 170 }}>
                                    <bs4.Input type="select" name="type" onBlur={(e) => this.handleChangeItem('a', e.target.name, e.target.value)}>
                                        <option value="">-----</option>
                                        {this.state.option_type}
                                    </bs4.Input>
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 130 }}>
                                    <bs4.Input type="select" name="color" onBlur={(e) => this.handleChangeItem('a', e.target.name, e.target.value)}>
                                        <option value="">-----</option>
                                        {this.state.option_color}
                                    </bs4.Input>
                                </bs4.Col>
                            </td>
                            <td style={{ fontWeight: 600 }}></td>
                            <td style={{ fontWeight: 600 }}>
                                <bs4.Col sm='12' style={{ width: 200 }}>
                                    <bs4.Input type="text" name="new_bom" onBlur={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td style={{ fontWeight: 600 }}>
                                <bs4.Col sm='12' style={{ width: 100 }}>
                                    <bs4.Input type="text" name="qty" onBlur={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td style={{ fontWeight: 600 }}>
                                <bs4.Col sm='12' style={{ width: 200 }}>
                                    <bs4.Input type="textarea" name="description" onBlur={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                        </tr>
                        {this._renderData()}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }

    _renderData() {
        return this.state.arr_save.map((val, i) =>
            <tr>
                <td style={{ fontWeight: 600 }}>{i + 1}</td>
                <td style={{ fontWeight: 600 }}>
                    <bs4.Col sm='12' style={{ width: 200 }}>
                        <bs4.Input type="text" name="ibrand1" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.ibrand1} />
                    </bs4.Col>
                </td>
                <td style={{ fontWeight: 600 }}>
                    <bs4.Col sm='12' style={{ width: 200 }}>
                        <bs4.Input type="text" name="itemG3" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.itemG3} />
                    </bs4.Col>
                </td>
                <td>
                    <bs4.Col sm='12' style={{ width: 170 }}>
                        <bs4.Input type="select" name="size" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                            <option value={val.size}>{val.size}</option>
                            {this.state.option_size}
                        </bs4.Input>
                    </bs4.Col>
                </td>
                <td>
                    <bs4.Col sm='12' style={{ width: 150 }}>
                        <bs4.Input type="select" name="front_back" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                            <option value={val.front_back}>{val.front_back}</option>
                            <option value="F">F</option>
                            <option value="F+B">F+B</option>
                        </bs4.Input>
                    </bs4.Col>
                </td>
                <td>
                    <bs4.Col sm='12' style={{ width: 170 }}>
                        <bs4.Input type="select" name="type" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                            <option value={val.type}>{val.type}</option>
                            {this.state.option_type}
                        </bs4.Input>
                    </bs4.Col>
                </td>
                <td>
                    <bs4.Col sm='12' style={{ width: 130 }}>
                        <bs4.Input type="select" name="color" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                            <option value={val.color}>{val.color}</option>
                            {this.state.option_color}
                        </bs4.Input>
                    </bs4.Col>
                </td>
                <td style={{ fontWeight: 600 }}>{val.line_num}</td>
                <td style={{ fontWeight: 600 }}>
                    <bs4.Col sm='12' style={{ width: 200 }}>
                        <bs4.Input type="text" name="new_bom" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.new_bom} />
                    </bs4.Col>
                </td>
                <td style={{ fontWeight: 600 }}>
                    <bs4.Col sm='12' style={{ width: 100 }}>
                        <bs4.Input type="text" name="qty" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.qty} />
                    </bs4.Col>
                </td>
                <td style={{ fontWeight: 600 }}>
                    <bs4.Col sm='12' style={{ width: 200 }}>
                        <bs4.Input type="textarea" name="description" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.description} />
                    </bs4.Col>
                </td>
            </tr>
        )
    }
}

export default Flim_EditMasterBomLine